import ProcessHero from "./ProcessHero";
import ProcessSwitchTabs from "./ProcessSwitchTabs";
import Footer from "../../../global/footer/Footer";
import "./Process.css";

import ScrollTop from "../../../components/ScrollTop";

export default function Process() {
  return (
    <>
      <ProcessHero />
      <ProcessSwitchTabs />
      <ScrollTop />
      <Footer />
    </>
  );
}
